function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40",
  height: "37",
  viewBox: "0 0 40 37",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon/map",
  transform: "translate(0 -2)",
  fill: "#000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_Map_1909219",
  transform: "translate(0 2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.5 11.288l-.1 1.036c-.45.058-.9.23-1.3.46 0 0-.05 0-.05.058l-.5-.863c.05-.058.1-.058.15-.058.6-.403 1.15-.576 1.8-.633zM22.9 13.303l.5.864c-.35.345-.7.748-1.05 1.209l-.55-.806c.3-.46.7-.864 1.1-1.267zM30.35 11.921l-.4.921c-.5-.172-.95-.345-1.4-.46l.1-1.037c.5.173 1.05.346 1.7.576z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 14.57l5.7 21.706 8.2-5.585 9.5.576 6.3-6.68 10.3-.863-7.75-18.309-8.8-.403-5.9 5.7-1.65-.288c-.2.346-.45.806-.7 1.267l2.1.345 1.8 6.334c-.15.23-.3.518-.45.748-.1.173-.2.346-.35.518l.6.691c.15-.23.25-.403.4-.633.05-.058.05-.115.1-.173l2.95 10.306-8.75-.518-7.2 4.894-2.3-8.694c.25.115.5.173.75.288l.25-.921c-.5-.173-.95-.346-1.35-.518l-2.4-9.097 4.9-3.57c-.25-.46-.45-.806-.65-1.152L0 14.57zm20.3 3.57l.6-.864-.55-.749c-.1.173-.25.346-.35.518l-1.5-5.297 5.45-5.239 7.55.23 3.75 8.867c-.15-.115-.35-.288-.5-.403l-.4.864c.55.46 1.15.92 1.75 1.44l2.1 5.008-8.85.749-5.85 6.045-3.2-11.17z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.05 6.045c0 1.471.55 2.732 1.3 3.835 1.2 1.786 4.4 7.51 4.4 7.51s3.2-5.672 4.4-7.51c.75-1.103 1.3-2.364 1.3-3.835 0-3.309-2.55-5.987-5.7-5.987-3.15 0-5.7 2.678-5.7 5.987zm2.6-.42c0-1.786 1.4-3.256 3.1-3.256 1.7 0 3.1 1.47 3.1 3.256 0 1.786-1.4 3.257-3.1 3.257-1.7-.053-3.1-1.47-3.1-3.257zM13.55 26.833l-.25-1.036c.4-.23.75-.576 1.15-.921l.65.748c-.55.46-1.05.864-1.55 1.21zM7.65 27.121l-1.5-.345.3-.979c.45.115.95.23 1.4.345l-.2.98zM16.55 23.897l-.65-.749c.35-.46.7-.978 1.05-1.496l.65.748c-.35.518-.7 1.036-1.05 1.497zM11.3 26.488l.25.979h-.65c-.35 0-.75 0-1.15-.058l.2-.979c.5.058.95.058 1.35.058z",
  id: "Shape"
})), /*#__PURE__*/React.createElement("path", {
  d: "M33.7 13.764l-.45.863c-.5-.345-.95-.633-1.4-.863l.4-.922c.45.288.95.634 1.45.922z",
  id: "Shape"
}))))));